import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { ExportAccountsOptions } from "../../../types/enums";
import { useMemo } from "react";

type Props = {
  option: string;
  isSelectedAll: boolean;
  selectedItemList: string[];
  setOption: (el: string) => void;
};

export const SelectedExportOptions = ({
  option,
  selectedItemList,
  isSelectedAll,
  setOption,
}: Props) => {
  const optionList = useMemo(
    () => [
      {
        label: ExportAccountsOptions.all,
        disabled: false,
        value: ExportAccountsOptions.all,
      },

      {
        label: `${ExportAccountsOptions.selected}${
          option === ExportAccountsOptions.selected
            ? `: ${isSelectedAll ? "All" : selectedItemList.length}`
            : ""
        }`,
        disabled: false,
        value: ExportAccountsOptions.selected,
      },
    ],
    [isSelectedAll, option, selectedItemList],
  );

  return (
    <FormControl sx={{ padding: "0 12px", alignItems: "flex-start" }}>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue={option}
        value={option}
        name="radio-buttons-group"
        onChange={(e, el) => setOption(el)}
      >
        {optionList.map(({ label, value }) => (
          <FormControlLabel
            key={label}
            value={value}
            control={<Radio />}
            label={label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
